import React from 'react';
import flashChecker from '../../utils/FlashChecker';
import './styles.less';
import icon from './Close.png';

export interface FlashTipsProps {
	show: boolean;
	close: () => void;
	newWindow: () => void;
}

export const FlashTips: React.FC<FlashTipsProps> = props => {
	
	const { show, close, newWindow } = props;

	return (
		flashChecker().f === 0 && show === true ?
			<div className='flash-tips'>
				<div className='flash-tips-center'>
					<div>
						<img onClick={close} className='flash-tips-close' src={icon} alt="" />
						<span className='flash-tips-text'>您的浏览器尚未开启Flash插件，请开启插件后使用此应用</span>
					</div>
					<button onClick={newWindow} className='flash-tips-button'>开启教程</button>
				</div>
			</div>
			: null
	)
}

export default FlashTips;
